
export function saveCache(code, value) {
    localStorage.setItem(code, JSON.stringify(value));
}


export function loadCache(code) {
    var cache = localStorage.getItem(code);
    if (cache != null && cache != 'undefined') {
        return JSON.parse(cache);
    }  
    return null;
}